import * as types from '../actions/_types';
import { updateObject } from '../../shared/utility';

export const initialState = {
  _loading: false,
  _error: null,
  data: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case types.DASHBOARD_FETCH_START:
      return updateObject(state, { _loading: true, _error: null });
    case types.DASHBOARD_FETCH_SUCCESS:
      return updateObject(state, { _loading: false, data: action.data });
    case types.DASHBOARD_FETCH_FAIL:
      return updateObject(state, { _loading: false, _error: action.error });
    default:
      return state;
  }
};
